import reducer from "./reducer";
export { default as OnboardingMaterials } from "./components/index";
export { default as onboardingMaterialsReducerName } from "./constants";
export default reducer;
